<template>
  <b-form @submit.prevent="onSubmit" novalidate>
    <b-form-row class="align-items-center">
      <b-col cols="12" md>
        <b-form-textarea v-model="form.content" v-focus :state="isValidField('content')" rows="3" />
      </b-col>
      <b-col cols="12" md="auto" class="text-right p-3">
        <b-button :disabled="submitting" pill variant="outline-primary" class="mr-2" @click="$emit('cancel')">Cancel</b-button>
        <b-button type="submit" :disabled="submitting" pill variant="primary" class="pl-4 pr-4">
          {{ edit ? 'Update' : 'Add' }}
        </b-button>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
import validator from 'validator'
import MixinForm from './MixinForm'

export default {
  name: 'EditPriorityForm',

  mixins: [MixinForm],

  props: {
    content: {
      type: String,
      default: ''
    },

    edit: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    content(value) {
      this.form.content = value
    }
  },

  data() {
    return {
      form: {
        content: this.content
      }
    }
  },

  methods: {
    validate(data) {
      const errors = {}
      if (validator.isEmpty(data.content)) errors.content = ["Can't be blank"]
      return errors
    }
  }
}
</script>
